import React from 'react'
import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField'
import { retrieveSchema } from 'react-jsonschema-form/lib/utils'
import classnames from 'classnames';
import './SectionField.scss';

export default class SectionField extends ObjectField {
  render() {
    const {
      uiSchema,
      errorSchema,
      idSchema,
      required,
      disabled,
      readonly,
      onBlur,
      formData
    } = this.props
    
    const { definitions, fields, formContext } = this.props.registry
    const { SchemaField, TitleField, DescriptionField } = fields
    const schema = retrieveSchema(this.props.schema, definitions)
    const title = schema.title
    const sections = uiSchema['ui:section']

    return (<div className='react-jsonschema-form-section'>
      {
        sections.map(({ classNames, items = [] }, idx)=>{
          return ( 
            <section className={classnames(classNames)} key={idx}>
              {
                Object.keys(items).map((name, fieldIdx) =>{
                let item = items[name];
                if (item.shown !== false) {
                  return (
                    <div className={classnames('form-field', item.className, { 'inline-form-field': item.inline == true })} key={fieldIdx}>
                      { item.beforeContent && <div className='before-content'>{item.beforeContent}</div> }
                        <div className='form-field-input'>
                          <SchemaField
                             key={idx}
                             name={name}
                             required={this.isRequired(name)}
                             schema={schema.properties[name] || {}}
                             uiSchema={item}
                             errorSchema={errorSchema[name]}
                             idSchema={idSchema[name]}
                             formData={formData[name]}
                             onChange={this.onPropertyChange(name)}
                             onBlur={onBlur}
                             registry={this.props.registry}
                             disabled={disabled}
                             readonly={readonly} />
                         { item.afterContent && <div className='after-content'>{item.afterContent}</div> }
                       </div>
                     </div>
                   );
                  }
                })
              }
            </section>
          );    
        })
      }
    </div>)
   } 
 }



// WEBPACK FOOTER //
// ./src/vendor/react-jsonschema-form-section/index.js